import React from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

// Page-level boundary: a crash in one screen shows an inline error instead of
// blanking the app, and navigating to another route clears it automatically.
const RouteErrorBoundary = ({ children }) => {
  const location = useLocation();
  return (
    <ErrorBoundary
      label={location.pathname}
      resetKey={location.pathname}
      title="This page failed to load"
    >
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
